// Login.js - Version: v1 i4

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css"; // 💅 Stellt sicher, dass das CSS angewendet wird

export default function Login({ setRole, setToken }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const logo = "/logo192.png"; // 🔍 Logo aus dem /public/-Ordner laden

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch("https://freiseinapp.de/api/auth.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();
      console.log("🔍 API-Antwort:", data);

      if (data.token && data.role) {
        console.log("✅ Token empfangen:", data.token);
        console.log("✅ Rolle empfangen:", data.role);
        console.log("🔍 kontakt_id empfangen:", data.kontakt_id);

        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.role);
        localStorage.setItem("email", email);
        if (data.kontakt_id) {
          localStorage.setItem("kontakt_id", data.kontakt_id);
          console.log("✅ kontakt_id gespeichert:", data.kontakt_id);
        } else {
          console.warn("⚠️ kontakt_id ist undefined und wurde nicht gespeichert!");
        }

        setToken(data.token);
        setRole(data.role); // 🟢 WICHTIG: Rolle setzen

        // 🔄 Automatische Weiterleitung basierend auf der Rolle
        switch (data.role) {
          case "admin":
            navigate("/admin");
            break;
          case "client":
            navigate("/client-dashboard");
            break;
          case "test":
            navigate("/test-dashboard");
            break;
          default:
            console.error("❌ Fehler: Unbekannte Rolle:", data.role);
            setMessage("❌ Fehler: Unbekannte Rolle.");
        }
      } else {
        console.error("❌ Fehler: Token oder Rolle fehlen in der API-Antwort:", data);
        setMessage("❌ Login fehlgeschlagen. Bitte überprüfe deine Zugangsdaten.");
      }
    } catch (error) {
      console.error("❌ Netzwerkfehler:", error);
      setMessage("❌ Netzwerkfehler. Bitte versuche es später erneut.");
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="FreiSeinApp Logo" className="login-logo" />
        <h2>🔑 Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="E-Mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Anmelden</button>
        </form>
        {message && <p className="login-message">{message}</p>}

        {/* Passwort vergessen Link */}
        <p className="forgot-password">
          <a href="/forgot-password">❓ Passwort vergessen?</a>
        </p>

        {/* ✅ Neu anmelden Link mit Icon */}
        <p className="register-link">
          <a
            href="/neu-anmelden"
            onClick={(e) => {
              e.preventDefault();
              navigate("/neu-anmelden");
            }}
          >
            <i className="fas fa-user-plus"></i> Neu anmelden
          </a>
        </p>
      </div>
    </div>
  );
}
